import { documentsVerificationConfig, UNSUPPORTED_EVENT } from '../../constants/configs/documentsVerificationConfig';
import { UPLOADED_DOCUMENT_STATUSES } from '../../constants/common/miscellaneous';
import states from '../../constants/configs/states';

export const getVerificationDocumentsConfig = (stateCode, event, strict = false) => {
    const findConfig = () => {
        const findByEvent = event => [ ...documentsVerificationConfig[stateCode] ]
            .find(([ events ]) => events.includes(event));

        const foundConfig = findByEvent(event);

        if(foundConfig || strict) {
            return foundConfig;
        } else if ([
            states.PENNSYLVANIA,
            states.NEVADA,
            states.NEW_JERSEY,
            states.IDAHO,
            states.VIRGINIA,
            states.GEORGIA,
            states.MINNESOTA,
        ].some(st => st === stateCode)) {
            return findByEvent(UNSUPPORTED_EVENT);
        } else {
            return null;
        }
    };

    const [ , config ] = (entity => entity ? entity : [])(findConfig());

    return config;
};

export const getFirstEventEnum = (stateCode, event) => {
    const [ applicableEvents ] = (
        entity => entity ? entity : ['common.no_text']
    )([ ...documentsVerificationConfig[stateCode] ].find(([ events ]) => events.includes(event)));
    return applicableEvents[0];
};

export const checkIfConfigFails = (stateCode, event, strict = false) => {
    if(!documentsVerificationConfig[stateCode]) {
        return `UI does not support Upload Documents functionality for given state =${stateCode}=`;
    }

    let mandatoryDocumentThatIsNotFound = null;
    let categoryTypeWhereConfigIncorrect = null;

    if(![ ...documentsVerificationConfig[stateCode]].every(([, { documents = [] } = { documents: [] }]) => {
        return documents.every(
            d => {
                const { mandatoryDocuments = [], documentTypes = [], categoryType } = d;
                return mandatoryDocuments.every(md => {
                    const isMandatoryDocumentFoundInDocumentTypes = documentTypes.includes(md);
                    if(!isMandatoryDocumentFoundInDocumentTypes) {
                        mandatoryDocumentThatIsNotFound = md;
                        categoryTypeWhereConfigIncorrect = categoryType;
                    }
                    return isMandatoryDocumentFoundInDocumentTypes;
                });
            }
        );
    })){
        return `This mandatory document =${mandatoryDocumentThatIsNotFound}= is not included in =documentTypes= in =${categoryTypeWhereConfigIncorrect}= category`;
    }

    if(!getVerificationDocumentsConfig(stateCode, event, strict)) {
        return `UI does not support Upload Documents functionality for given event =${event}=`;
    }

    return;
};

export const getCategoryValidationRules = (categoryType, stateCode, event) => {
    return getVerificationDocumentsConfig(stateCode, event).documents.find(c => c.categoryType === categoryType);
};

export const checkIfAllDocumentsProvided = (stateCode, event, documents) => {

    if(checkIfConfigFails(stateCode, event)) {
        return;
    }

    return getVerificationDocumentsConfig(stateCode, event).documents.every(
        category => {
            const {
                categoryType,
                documentsQty,
                mandatoryDocuments = []
            } = category;

            // Finding corresponding documentTypes from BE data:

            const correspondingCategory = documents.find(c => c.categoryType === categoryType);

            if(!correspondingCategory) {
                return false;
            }

            const {
                documentTypes,
                overrideDone
            } = correspondingCategory;

            if(overrideDone) {
                return true;
            }

            const checkIfNotRejected = document => document.documentStatus !== UPLOADED_DOCUMENT_STATUSES.REJECTED;

            const filteredDocumentTypes = documentTypes
                .filter(d => category.documentTypes.includes(d.documentType))
                .filter(d => checkIfNotRejected(d));

            // 2 rules are applied:
            // - documents quantity;
            // - if mandatory types exist check if all of them are provided;

            return documentsQty <= filteredDocumentTypes.length &&
                (
                    mandatoryDocuments.length > 0 ?
                        mandatoryDocuments.every(
                            docType => (d => d ? checkIfNotRejected(d) : false)(filteredDocumentTypes.find(doc => doc.documentType === docType)))
                        : true
                );
        }
    );
};